import { useScript } from '@raskrask-dk/rr-components'
import { useTranslation } from 'react-i18next'

export const useCookiebot = (): void => {
    const { i18n } = useTranslation()
    useScript('https://consent.cookiebot.com/uc.js', {
        'data-culture': i18n.language === 'da-DK' ? 'da' : 'en',
        'data-cbid': '63ba6c5d-f037-4c45-81fa-6f3e8b6bf532',
        async: 'true',
    })
}
